export const mixedOptions = [
  {
    value: 'Mixed Breed Small',
    label: 'Mixed Breed Small (up to 22lb when full grown)',
  },
  {
    value: 'Mixed Breed Medium',
    label: 'Mixed Breed Medium (23 - 70lb when full grown)',
  },
  {
    value: 'Mixed Breed Large',
    label: 'Mixed Breed Large (71lb + when full grown)',
  },
];

export const breedOptions = [
  { value: 'Affenpinscher', label: 'Affenpinscher' },
  { value: 'Afghan Hound', label: 'Afghan Hound' },
  { value: 'Aidi', label: 'Aidi' },
  { value: 'Ainu Dog', label: 'Ainu Dog' },
  { value: 'Airedale Terrier', label: 'Airedale Terrier' },
  { value: 'Akbash Dog', label: 'Akbash Dog' },
  { value: 'Akita', label: 'Akita' },
  { value: 'Alano Espanol', label: 'Alano Espanol' },
  { value: 'Alapaha Blue Blood Bulldog', label: 'Alapaha Blue Blood Bulldog' },
  { value: 'Alaskan Husky', label: 'Alaskan Husky' },
  { value: 'Alaskan Klee Kai', label: 'Alaskan Klee Kai' },
  { value: 'Alaskan Malamute', label: 'Alaskan Malamute' },
  { value: 'Alpine Dachsbracke', label: 'Alpine Dachsbracke' },
  { value: 'Alsatian', label: 'Alsatian' },
  { value: 'American Bulldog', label: 'American Bulldog' },
  { value: 'American Bullnese', label: 'American Bullnese' },
  { value: 'American Bully', label: 'American Bully' },
  { value: 'American Cocker Spaniel', label: 'American Cocker Spaniel' },
  { value: 'American Eskimo Dog', label: 'American Eskimo Dog' },
  {
    value: 'American Eskimo Dog - miniature',
    label: 'American Eskimo Dog - miniature',
  },
  { value: 'American Foxhound', label: 'American Foxhound' },
  { value: 'American Hairless Terrier', label: 'American Hairless Terrier' },
  { value: 'American Indian Dog', label: 'American Indian Dog' },
  { value: 'American Lo-Sze Pugg', label: 'American Lo-Sze Pugg' },
  { value: 'American Mastiff', label: 'American Mastiff' },
  { value: 'American Pit Bull Terrier', label: 'American Pit Bull Terrier' },
  {
    value: 'American Staffordshire Terrier',
    label: 'American Staffordshire Terrier',
  },
  { value: 'American Staghound', label: 'American Staghound' },
  { value: 'American Tundra Shepherd', label: 'American Tundra Shepherd' },
  { value: 'American Water Spaniel', label: 'American Water Spaniel' },
  { value: 'American White Shepherd', label: 'American White Shepherd' },
  { value: 'Anatolian Shepherd Dog', label: 'Anatolian Shepherd Dog' },
  { value: 'Appenzell Mountain Dog', label: 'Appenzell Mountain Dog' },
  { value: 'Argentine Dogo', label: 'Argentine Dogo' },
  { value: 'Ariegoeis', label: 'Ariegoeis' },
  { value: 'Australian Cattle Dog', label: 'Australian Cattle Dog' },
  { value: 'Australian Kelpie', label: 'Australian Kelpie' },
  { value: 'Australian Shepherd', label: 'Australian Shepherd' },
  {
    value: 'Australian Shepherd - miniature',
    label: 'Australian Shepherd - miniature',
  },
  { value: 'Australian Terrier', label: 'Australian Terrier' },
  { value: 'Austrian Brandlbracke', label: 'Austrian Brandlbracke' },
  {
    value: 'Austrian Shorthaired Pinscher',
    label: 'Austrian Shorthaired Pinscher',
  },
  { value: 'Azawakh', label: 'Azawakh' },
  { value: 'Barbet', label: 'Barbet' },
  { value: 'Basenji', label: 'Basenji' },
  { value: 'Basset Artesien Normand', label: 'Basset Artesien Normand' },
  { value: 'Basset Bleu De Gascogne', label: 'Basset Bleu De Gascogne' },
  { value: 'Basset Fauve De Bretagne', label: 'Basset Fauve De Bretagne' },
  { value: 'Basset Hound', label: 'Basset Hound' },
  { value: 'Beagle', label: 'Beagle' },
  { value: 'Bearded Collie', label: 'Bearded Collie' },
  { value: 'Beauceron', label: 'Beauceron' },
  { value: 'Bedlington Terrier', label: 'Bedlington Terrier' },
  {
    value: 'Belgian Shepherd Groenendael',
    label: 'Belgian Shepherd Groenendael',
  },
  { value: 'Belgian Shepherd Laekenois', label: 'Belgian Shepherd Laekenois' },
  { value: 'Belgian Shepherd Malinois', label: 'Belgian Shepherd Malinois' },
  { value: 'Belgian Shepherd Tervuren', label: 'Belgian Shepherd Tervuren' },
  { value: 'Bergamasco', label: 'Bergamasco' },
  { value: 'Berger des Pyrenees', label: 'Berger des Pyrenees' },
  { value: 'Berger Picard', label: 'Berger Picard' },
  { value: 'Bernese Mountain Dog', label: 'Bernese Mountain Dog' },
  { value: 'Bichon Frise', label: 'Bichon Frise' },
  { value: 'Biewer', label: 'Biewer' },
  { value: 'Black Mouth Cur', label: 'Black Mouth Cur' },
  { value: 'Black Russian Terrier', label: 'Black Russian Terrier' },
  { value: 'Bloodhound', label: 'Bloodhound' },
  { value: 'Blue Heeler', label: 'Blue Heeler' },
  { value: 'Blue Lacy', label: 'Blue Lacy' },
  { value: 'Bluetick Coonhound', label: 'Bluetick Coonhound' },
  { value: 'Boerboel', label: 'Boerboel' },
  { value: 'Bolognese', label: 'Bolognese' },
  { value: 'Bolonka', label: 'Bolonka' },
  { value: 'Border Collie', label: 'Border Collie' },
  { value: 'Border Terrier', label: 'Border Terrier' },
  { value: 'Borzoi', label: 'Borzoi' },
  {
    value: 'Bosnian Coarse Haired Hound',
    label: 'Bosnian Coarse Haired Hound',
  },
  { value: 'Boston Terrier', label: 'Boston Terrier' },
  { value: 'Bouvier Des Flandres', label: 'Bouvier Des Flandres' },
  { value: 'Boxer', label: 'Boxer' },
  { value: 'Boykin Spaniel', label: 'Boykin Spaniel' },
  { value: 'Bracco Italiano', label: 'Bracco Italiano' },
  { value: 'Braque d Auvergne', label: 'Braque d Auvergne' },
  { value: 'Braque du Bourbonnais', label: 'Braque du Bourbonnais' },
  { value: 'Braque Francais', label: 'Braque Francais' },
  { value: 'Brazilian Fila', label: 'Brazilian Fila' },
  { value: 'Brazilian Terrier', label: 'Brazilian Terrier' },
  { value: 'Briard', label: 'Briard' },
  { value: 'Briquet Griffon Vendeen', label: 'Briquet Griffon Vendeen' },
  { value: 'Brittany', label: 'Brittany' },
  { value: 'Brussels Griffon', label: 'Brussels Griffon' },
  { value: 'Bull Terrier', label: 'Bull Terrier' },
  { value: 'Bull Terrier - miniature', label: 'Bull Terrier - miniature' },
  { value: 'BullBoxer', label: 'BullBoxer' },
  { value: 'Bulldog', label: 'Bulldog' },
  { value: 'Bullmastiff', label: 'Bullmastiff' },
  { value: 'Ca de Bou', label: 'Ca de Bou' },
  { value: 'Cairn Terrier', label: 'Cairn Terrier' },
  { value: 'Canaan Dog', label: 'Canaan Dog' },
  { value: 'Canadian Eskimo Dog', label: 'Canadian Eskimo Dog' },
  { value: 'Canary Dog', label: 'Canary Dog' },
  { value: 'Cane Corso', label: 'Cane Corso' },
  { value: 'Cao de Fila de Sao Miguel', label: 'Cao de Fila de Sao Miguel' },
  { value: 'Cardigan Welsh Corgi', label: 'Cardigan Welsh Corgi' },
  { value: 'Carolina Dog', label: 'Carolina Dog' },
  { value: 'Catahoula Leopard Dog', label: 'Catahoula Leopard Dog' },
  { value: 'Caucasian Ovtcharka', label: 'Caucasian Ovtcharka' },
  { value: 'Cavachon', label: 'Cavachon' },
  {
    value: 'Cavalier King Charles Spaniel',
    label: 'Cavalier King Charles Spaniel',
  },
  { value: 'Central Asian Ovtcharka', label: 'Central Asian Ovtcharka' },
  { value: 'Cesky Fousek', label: 'Cesky Fousek' },
  { value: 'Cesky Terrier', label: 'Cesky Terrier' },
  { value: 'Chasa Apso', label: 'Chasa Apso' },
  { value: 'Chesapeake Bay Retriever', label: 'Chesapeake Bay Retriever' },
  { value: 'Chien D Artois', label: 'Chien D Artois' },
  { value: 'Chihuahua', label: 'Chihuahua' },
  { value: 'Chihuahua long-haired', label: 'Chihuahua long-haired' },
  { value: 'Chinese Chongqing Dog', label: 'Chinese Chongqing Dog' },
  { value: 'Chinese Crested Dog', label: 'Chinese Crested Dog' },
  { value: 'Chinese Crested Hairless', label: 'Chinese Crested Hairless' },
  {
    value: 'Chinese Crested Powder Puff',
    label: 'Chinese Crested Powder Puff',
  },
  { value: 'Chinese Foo', label: 'Chinese Foo' },
  { value: 'Chinese Imperial', label: 'Chinese Imperial' },
  { value: 'Chinook', label: 'Chinook' },
  { value: 'Chow Chow', label: 'Chow Chow' },
  { value: 'Cirneco dell Etna', label: 'Cirneco dell Etna' },
  { value: 'Clumber Spaniel', label: 'Clumber Spaniel' },
  { value: 'Cockapoo', label: 'Cockapoo' },
  { value: 'Cocker Spaniel', label: 'Cocker Spaniel' },
  { value: 'Cocker Spaniel Miniature', label: 'Cocker Spaniel Miniature' },
  { value: 'Collie', label: 'Collie' },
  { value: 'Collie smooth-coated', label: 'Collie smooth-coated' },
  { value: 'Coonhound - black and tan', label: 'Coonhound - black and tan' },
  { value: 'Coonhound - blue tick', label: 'Coonhound - blue tick' },
  { value: 'Coonhound - red bone', label: 'Coonhound - red bone' },
  { value: 'Corgi', label: 'Corgi' },
  { value: 'Coton De Tulear', label: 'Coton De Tulear' },
  { value: 'Curly-Coated Retriever', label: 'Curly-Coated Retriever' },
  {
    value: 'Czechoslovakian Wolfdog (Vlcak)',
    label: 'Czechoslovakian Wolfdog (Vlcak)',
  },
  { value: 'Dachshund', label: 'Dachshund' },
  { value: 'Dachshund - long haired', label: 'Dachshund - long haired' },
  { value: 'Dachshund - smooth coat', label: 'Dachshund - smooth coat' },
  { value: 'Dachshund - wire haired', label: 'Dachshund - wire haired' },
  {
    value: 'Dachshund miniature - long haired',
    label: 'Dachshund miniature - long haired',
  },
  {
    value: 'Dachshund miniature - smooth coat',
    label: 'Dachshund miniature - smooth coat',
  },
  {
    value: 'Dachshund miniature - wire haired',
    label: 'Dachshund miniature - wire haired',
  },
  { value: 'Dalmatian', label: 'Dalmatian' },
  { value: 'Dandie Dinmont Terrier', label: 'Dandie Dinmont Terrier' },
  { value: 'Danish-Swedish Farmdog', label: 'Danish-Swedish Farmdog' },
  { value: 'Deerhound', label: 'Deerhound' },
  { value: 'Deutsch Drahthaar', label: 'Deutsch Drahthaar' },
  { value: 'Deutscher Wachtelhund', label: 'Deutscher Wachtelhund' },
  { value: 'Doberman Pinscher', label: 'Doberman Pinscher' },
  { value: 'Dogo Argentino', label: 'Dogo Argentino' },
  { value: 'Dogue De Bordeaux', label: 'Dogue De Bordeaux' },
  { value: 'Dorgie', label: 'Dorgie' },
  { value: 'Drever', label: 'Drever' },
  { value: 'Dunker', label: 'Dunker' },
  { value: 'Dutch Sheepdog', label: 'Dutch Sheepdog' },
  { value: 'Dutch Shepherd', label: 'Dutch Shepherd' },
  { value: 'Dutch Smoushond', label: 'Dutch Smoushond' },
  { value: 'Elkhound', label: 'Elkhound' },
  { value: 'English Bulldog', label: 'English Bulldog' },
  { value: 'English Cocker Spaniel', label: 'English Cocker Spaniel' },
  { value: 'English Coonhound', label: 'English Coonhound' },
  { value: 'English Foxhound', label: 'English Foxhound' },
  { value: 'English Mastiff', label: 'English Mastiff' },
  { value: 'English Pointer', label: 'English Pointer' },
  { value: 'English Setter', label: 'English Setter' },
  { value: 'English Shepherd', label: 'English Shepherd' },
  { value: 'English Springer Spaniel', label: 'English Springer Spaniel' },
  { value: 'English Toy Spaniel', label: 'English Toy Spaniel' },
  { value: 'English Toy Terrier', label: 'English Toy Terrier' },
  { value: 'Entlebucher Mountain Dog', label: 'Entlebucher Mountain Dog' },
  { value: 'Eskimo Dog', label: 'Eskimo Dog' },
  { value: 'Estonian Hound', label: 'Estonian Hound' },
  { value: 'Estrela Mountain Dog', label: 'Estrela Mountain Dog' },
  { value: 'Eurasier', label: 'Eurasier' },
  { value: 'Fell Terrier', label: 'Fell Terrier' },
  { value: 'Field Spaniel', label: 'Field Spaniel' },
  { value: 'Fila Brasileiro', label: 'Fila Brasileiro' },
  { value: 'Finnish Hound', label: 'Finnish Hound' },
  { value: 'Finnish Lapphund', label: 'Finnish Lapphund' },
  { value: 'Finnish Spitz', label: 'Finnish Spitz' },
  { value: 'Flat-coated Retriever', label: 'Flat-coated Retriever' },
  { value: 'Fox Hound', label: 'Fox Hound' },
  { value: 'Fox Terrier', label: 'Fox Terrier' },
  { value: 'French Bulldog', label: 'French Bulldog' },
  { value: 'French Mastiff', label: 'French Mastiff' },
  { value: 'French Spaniel', label: 'French Spaniel' },
  { value: 'Gazelle Hound', label: 'Gazelle Hound' },
  { value: 'German Longhaired Pointer', label: 'German Longhaired Pointer' },
  { value: 'German Pinscher', label: 'German Pinscher' },
  { value: 'German Shepherd', label: 'German Shepherd' },
  { value: 'German Shorthaired Pointer', label: 'German Shorthaired Pointer' },
  { value: 'German Spitz', label: 'German Spitz' },
  { value: 'German Wirehaired Pointer', label: 'German Wirehaired Pointer' },
  { value: 'Giant Schnauzer', label: 'Giant Schnauzer' },
  { value: 'Glen Of Imaal Terrier', label: 'Glen Of Imaal Terrier' },
  { value: 'Golden Labrador (hybrid)', label: 'Golden Labrador (hybrid)' },
  { value: 'Golden Retriever', label: 'Golden Retriever' },
  { value: 'Goldendoodle', label: 'Goldendoodle' },
  { value: 'Gordon Setter', label: 'Gordon Setter' },
  { value: 'Gran Mastin de Borinquen', label: 'Gran Mastin de Borinquen' },
  {
    value: 'Grand Basset Griffon Vendeen',
    label: 'Grand Basset Griffon Vendeen',
  },
  { value: 'Grand Bleu de Gascogne', label: 'Grand Bleu de Gascogne' },
  { value: 'Great Dane', label: 'Great Dane' },
  { value: 'Great Pyrenean', label: 'Great Pyrenean' },
  { value: 'Great Pyrenees', label: 'Great Pyrenees' },
  { value: 'Greater Swiss Mountain Dog', label: 'Greater Swiss Mountain Dog' },
  { value: 'Greenland Dog', label: 'Greenland Dog' },
  { value: 'Greyhound', label: 'Greyhound' },
  { value: 'Griffon Bruxellois', label: 'Griffon Bruxellois' },
  { value: 'Groenendael', label: 'Groenendael' },
  { value: 'Hamiltonstovare', label: 'Hamiltonstovare' },
  { value: 'Harrier', label: 'Harrier' },
  { value: 'Havanese', label: 'Havanese' },
  { value: 'Hovawart', label: 'Hovawart' },
  { value: 'Hungarian Kuvasz', label: 'Hungarian Kuvasz' },
  { value: 'Hungarian Puli', label: 'Hungarian Puli' },
  { value: 'Hungarian Pumi', label: 'Hungarian Pumi' },
  { value: 'Hungarian Sheepdog', label: 'Hungarian Sheepdog' },
  { value: 'Hungarian Vizsla', label: 'Hungarian Vizsla' },
  {
    value: 'Hungarian Wire Haired Vizsla',
    label: 'Hungarian Wire Haired Vizsla',
  },
  { value: 'Ibizan Hound', label: 'Ibizan Hound' },
  { value: 'Icelandic Sheepdog', label: 'Icelandic Sheepdog' },
  { value: 'Inca Hairless Dog', label: 'Inca Hairless Dog' },
  { value: 'Inca Orchid', label: 'Inca Orchid' },
  { value: 'Irish Red and White Setter', label: 'Irish Red and White Setter' },
  { value: 'Irish Setter', label: 'Irish Setter' },
  {
    value: 'Irish Staffordshire Bull Terrier',
    label: 'Irish Staffordshire Bull Terrier',
  },
  { value: 'Irish Terrier', label: 'Irish Terrier' },
  { value: 'Irish Water Spaniel', label: 'Irish Water Spaniel' },
  { value: 'Irish Wolfhound', label: 'Irish Wolfhound' },
  { value: 'Italian Greyhound', label: 'Italian Greyhound' },
  { value: 'Jack Russell Terrier', label: 'Jack Russell Terrier' },
  { value: 'Japanese Chin', label: 'Japanese Chin' },
  { value: 'Japanese Spitz', label: 'Japanese Spitz' },
  { value: 'Japanese Terrier', label: 'Japanese Terrier' },
  { value: 'Kai Dog', label: 'Kai Dog' },
  { value: 'Kangal Dog', label: 'Kangal Dog' },
  { value: 'Karabash', label: 'Karabash' },
  { value: 'Karelian Bear Dog', label: 'Karelian Bear Dog' },
  { value: 'Keeshond', label: 'Keeshond' },
  { value: 'Kelpie', label: 'Kelpie' },
  { value: 'Kerry Blue Terrier', label: 'Kerry Blue Terrier' },
  { value: 'King Charles Spaniel', label: 'King Charles Spaniel' },
  { value: 'King Shepherd', label: 'King Shepherd' },
  { value: 'Kishu Inu', label: 'Kishu Inu' },
  { value: 'Komondor', label: 'Komondor' },
  { value: 'Kooikerhondje', label: 'Kooikerhondje' },
  { value: 'Koolie', label: 'Koolie' },
  { value: 'Korean Jindo', label: 'Korean Jindo' },
  { value: 'Kuvasz', label: 'Kuvasz' },
  { value: 'Kyi-Leo', label: 'Kyi-Leo' },
  { value: 'Labradoodle', label: 'Labradoodle' },
  { value: 'Labrador Husky', label: 'Labrador Husky' },
  { value: 'Labrador Retriever', label: 'Labrador Retriever' },
  { value: 'Labrador Retriever - Black', label: 'Labrador Retriever - Black' },
  {
    value: 'Labrador Retriever - Chocolate',
    label: 'Labrador Retriever - Chocolate',
  },
  {
    value: 'Labrador Retriever - Yellow',
    label: 'Labrador Retriever - Yellow',
  },
  { value: 'Laekenois', label: 'Laekenois' },
  { value: 'Lagotto Romagnolo', label: 'Lagotto Romagnolo' },
  { value: 'Lakeland Terrier', label: 'Lakeland Terrier' },
  { value: 'Lancashire Heeler', label: 'Lancashire Heeler' },
  { value: 'Landseer', label: 'Landseer' },
  { value: 'Lapinporokoira', label: 'Lapinporokoira' },
  { value: 'Large Munsterlander', label: 'Large Munsterlander' },
  { value: 'Leonberger', label: 'Leonberger' },
  { value: 'Lhasa Apso', label: 'Lhasa Apso' },
  { value: 'Llewellin Setter', label: 'Llewellin Setter' },
  {
    value: 'Louisiana Catahoula Leopard Dog',
    label: 'Louisiana Catahoula Leopard Dog',
  },
  { value: 'Lowchen', label: 'Lowchen' },
  { value: 'Lucas Terrier', label: 'Lucas Terrier' },
  { value: 'Lurcher', label: 'Lurcher' },
  { value: 'Malamute Husky', label: 'Malamute Husky' },
  { value: 'Malinois', label: 'Malinois' },
  { value: 'Maltipoo', label: 'Maltipoo' },
  { value: 'Maltese', label: 'Maltese' },
  { value: 'Manchester Terrier', label: 'Manchester Terrier' },
  { value: 'Maremma Sheepdog', label: 'Maremma Sheepdog' },
  { value: 'Mastiff', label: 'Mastiff' },
  { value: 'Mexican Hairless Crested', label: 'Mexican Hairless Crested' },
  { value: 'Mexican Hairless Dog', label: 'Mexican Hairless Dog' },
  { value: 'Miki', label: 'Miki' },
  { value: 'Miniature Dachshund', label: 'Miniature Dachshund' },
  { value: 'Miniature Pinscher', label: 'Miniature Pinscher' },
  { value: 'Miniature Poodle', label: 'Miniature Poodle' },
  { value: 'Miniature Schnauzer', label: 'Miniature Schnauzer' },
  { value: 'Mioritic Sheepdog', label: 'Mioritic Sheepdog' },
  { value: 'Mountain Cur', label: 'Mountain Cur' },
  { value: 'Mountain Feist', label: 'Mountain Feist' },
  { value: 'Mudi', label: 'Mudi' },
  { value: 'Native American Indian Dog', label: 'Native American Indian Dog' },
  { value: 'Neapolitan Mastiff', label: 'Neapolitan Mastiff' },
  { value: 'Nebolish Mastiff', label: 'Nebolish Mastiff' },
  {
    value: 'New Zealand Huntaway (Sheepdog)',
    label: 'New Zealand Huntaway (Sheepdog)',
  },
  { value: 'Newfoundland', label: 'Newfoundland' },
  { value: 'Nippon Terrier', label: 'Nippon Terrier' },
  { value: 'Norfolk Terrier', label: 'Norfolk Terrier' },
  { value: 'Northern Inuit Dog', label: 'Northern Inuit Dog' },
  { value: 'Norwegian Buhund', label: 'Norwegian Buhund' },
  { value: 'Norwegian Elkhound', label: 'Norwegian Elkhound' },
  { value: 'Norwegian Lundehund', label: 'Norwegian Lundehund' },
  { value: 'Norwich Terrier', label: 'Norwich Terrier' },
  {
    value: 'Nova Scotia Duck Tolling Retriever',
    label: 'Nova Scotia Duck Tolling Retriever',
  },
  { value: 'Old English Mastiff', label: 'Old English Mastiff' },
  { value: 'Old English Sheepdog', label: 'Old English Sheepdog' },
  { value: 'Olde English Bulldogge', label: 'Olde English Bulldogge' },
  { value: 'Olde Victorian Bulldogge', label: 'Olde Victorian Bulldogge' },
  { value: 'Ori Pei', label: 'Ori Pei' },
  { value: 'Otterhound', label: 'Otterhound' },
  { value: 'Papillon', label: 'Papillon' },
  {
    value: 'Parson Jack Russell Terrier',
    label: 'Parson Jack Russell Terrier',
  },
  { value: 'Patterdale Terrier', label: 'Patterdale Terrier' },
  { value: 'Peek-a-poo', label: 'Peek-a-poo' },
  { value: 'Pekingese', label: 'Pekingese' },
  { value: 'Pembroke Welsh Corgi', label: 'Pembroke Welsh Corgi' },
  { value: 'Perro de Presa Mallorquin', label: 'Perro de Presa Mallorquin' },
  { value: 'Peruvian Inca Orchid', label: 'Peruvian Inca Orchid' },
  {
    value: 'Petit Basset Griffon Vendeen',
    label: 'Petit Basset Griffon Vendeen',
  },
  { value: 'Petit Brabancon', label: 'Petit Brabancon' },
  { value: 'Pharaoh Hound', label: 'Pharaoh Hound' },
  { value: 'Pit Bull', label: 'Pit Bull' },
  { value: 'Plott Hound', label: 'Plott Hound' },
  { value: 'Pointer', label: 'Pointer' },
  { value: 'Polish Lowland Sheepdog', label: 'Polish Lowland Sheepdog' },
  { value: 'Polish Tatra Sheepdog', label: 'Polish Tatra Sheepdog' },
  { value: 'Pomeranian', label: 'Pomeranian' },
  { value: 'Poodle', label: 'Poodle' },
  { value: 'Poodle - Giant', label: 'Poodle - Giant' },
  { value: 'Poodle - Miniature', label: 'Poodle - Miniature' },
  { value: 'Poodle - Standard', label: 'Poodle - Standard' },
  { value: 'Poodle - Teacup', label: 'Poodle - Teacup' },
  { value: 'Poodle - Toy', label: 'Poodle - Toy' },
  { value: 'Porcelaine', label: 'Porcelaine' },
  {
    value: 'Portuguese Mastiff (Rafeiro Do Alentejo)',
    label: 'Portuguese Mastiff (Rafeiro Do Alentejo)',
  },
  { value: 'Portuguese Podengo', label: 'Portuguese Podengo' },
  { value: 'Portuguese Pointer', label: 'Portuguese Pointer' },
  { value: 'Portuguese Water Dog', label: 'Portuguese Water Dog' },
  { value: 'Presa Canario', label: 'Presa Canario' },
  { value: 'Pudelpointer', label: 'Pudelpointer' },
  { value: 'Pug', label: 'Pug' },
  { value: 'Puggle', label: 'Puggle' },
  { value: 'Puli', label: 'Puli' },
  { value: 'Pumi', label: 'Pumi' },
  { value: 'Pyrenean Mastiff', label: 'Pyrenean Mastiff' },
  { value: 'Pyrenean Mountain Dog', label: 'Pyrenean Mountain Dog' },
  { value: 'Pyrenean Shepherd', label: 'Pyrenean Shepherd' },
  { value: 'Queensland Heeler', label: 'Queensland Heeler' },
  { value: 'Rat Terrier', label: 'Rat Terrier' },
  { value: 'Rhodesian Ridgeback', label: 'Rhodesian Ridgeback' },
  { value: 'Rottweiler', label: 'Rottweiler' },
  { value: 'Rough Collie', label: 'Rough Collie' },
  { value: 'Saarlooswolfhond', label: 'Saarlooswolfhond' },
  { value: 'Saint Bernard', label: 'Saint Bernard' },
  { value: 'Saluki', label: 'Saluki' },
  { value: 'Samoyed', label: 'Samoyed' },
  { value: 'Sarplaninac', label: 'Sarplaninac' },
  { value: 'Schapendoes', label: 'Schapendoes' },
  { value: 'Schipperke', label: 'Schipperke' },
  { value: 'Schnauzer', label: 'Schnauzer' },
  { value: 'Schnauzer - giant', label: 'Schnauzer - giant' },
  { value: 'Schnauzer - miniature', label: 'Schnauzer - miniature' },
  { value: 'Schnauzer - standard', label: 'Schnauzer - standard' },
  { value: 'Schnoodle', label: 'Schnoodle' },
  { value: 'Scottish Deerhound', label: 'Scottish Deerhound' },
  { value: 'Scottish Terrier', label: 'Scottish Terrier' },
  { value: 'Sealyham Terrier', label: 'Sealyham Terrier' },
  { value: 'Segugio Italiano', label: 'Segugio Italiano' },
  { value: 'Shar-pei', label: 'Shar-pei' },
  { value: 'Shetland Sheepdog', label: 'Shetland Sheepdog' },
  { value: 'Shiba Inu', label: 'Shiba Inu' },
  { value: 'Shih Tzu', label: 'Shih Tzu' },
  { value: 'Shikoku', label: 'Shikoku' },
  { value: 'Shiloh Shepherd', label: 'Shiloh Shepherd' },
  { value: 'Siberian Husky', label: 'Siberian Husky' },
  { value: 'Silken Windhound', label: 'Silken Windhound' },
  { value: 'Silky Terrier', label: 'Silky Terrier' },
  { value: 'Skye Terrier', label: 'Skye Terrier' },
  { value: 'Sloughi', label: 'Sloughi' },
  { value: 'Small Munsterlander', label: 'Small Munsterlander' },
  { value: 'Smooth Collie', label: 'Smooth Collie' },
  { value: 'Smooth Fox Terrier', label: 'Smooth Fox Terrier' },
  {
    value: 'Soft Coated Wheaten Terrier',
    label: 'Soft Coated Wheaten Terrier',
  },
  { value: 'Spanish Bulldog', label: 'Spanish Bulldog' },
  { value: 'Spanish Mastiff', label: 'Spanish Mastiff' },
  { value: 'Spanish Water Dog', label: 'Spanish Water Dog' },
  { value: 'Spinone italiano', label: 'Spinone italiano' },
  { value: 'Spitz', label: 'Spitz' },
  { value: 'Stabyhoun (Stabij)', label: 'Stabyhoun (Stabij)' },
  { value: 'Staffordshire Bull Terrier', label: 'Staffordshire Bull Terrier' },
  { value: 'Staghound', label: 'Staghound' },
  { value: 'Sussex Spaniel', label: 'Sussex Spaniel' },
  { value: 'Swedish Elkhound', label: 'Swedish Elkhound' },
  { value: 'Swedish Lapphund', label: 'Swedish Lapphund' },
  { value: 'Swedish Vallhund', label: 'Swedish Vallhund' },
  { value: 'Tervuren', label: 'Tervuren' },
  { value: 'Thai Ridgeback', label: 'Thai Ridgeback' },
  { value: 'Tibetan KyiApso', label: 'Tibetan KyiApso' },
  { value: 'Tibetan Mastiff', label: 'Tibetan Mastiff' },
  { value: 'Tibetan Spaniel', label: 'Tibetan Spaniel' },
  { value: 'Tibetan Terrier', label: 'Tibetan Terrier' },
  { value: 'Tosa Inu', label: 'Tosa Inu' },
  { value: 'Toy Fox Terrier', label: 'Toy Fox Terrier' },
  { value: 'Toy Terrier', label: 'Toy Terrier' },
  { value: 'Treeing Tennessee Brindle', label: 'Treeing Tennessee Brindle' },
  { value: 'Treeing Walker Coonhound', label: 'Treeing Walker Coonhound' },
  { value: 'Victorian Bulldog', label: 'Victorian Bulldog' },
  { value: 'Vizsla', label: 'Vizsla' },
  { value: 'Volpino Italiano', label: 'Volpino Italiano' },
  { value: 'Weimaraner', label: 'Weimaraner' },
  { value: 'Welsh Corgi', label: 'Welsh Corgi' },
  { value: 'Welsh Corgi - Cardigan', label: 'Welsh Corgi - Cardigan' },
  { value: 'Welsh Corgi - Pembroke', label: 'Welsh Corgi - Pembroke' },
  { value: 'Welsh Springer Spaniel', label: 'Welsh Springer Spaniel' },
  { value: 'Welsh Terrier', label: 'Welsh Terrier' },
  {
    value: 'West Highland White Terrier',
    label: 'West Highland White Terrier',
  },
  { value: 'Wheaten Terrier', label: 'Wheaten Terrier' },
  { value: 'Whippet', label: 'Whippet' },
  { value: 'Wirehaired Fox Terrier', label: 'Wirehaired Fox Terrier' },
  {
    value: 'Wirehaired Pointing Griffon',
    label: 'Wirehaired Pointing Griffon',
  },
  { value: 'Wirehaired Vizsla', label: 'Wirehaired Vizsla' },
  {
    value: 'Xoloitzcuintli - Mexican Hairless Dog',
    label: 'Xoloitzcuintli - Mexican Hairless Dog',
  },
  { value: 'Yorkie-Poo', label: 'Yorkie-Poo' },
  { value: 'Yorkshire Terrier', label: 'Yorkshire Terrier' },
];

export const groupedOptions = [
  {
    label: 'Mixed Breeds',
    options: mixedOptions,
  },

  { label: 'Breeds', options: breedOptions },
];
